import React from 'react'
import { Box } from '@mui/material'
import { TempNavbar } from '../component/shared/TempNavbar'
import ResetPasswwordForm from '../component/auth/ResetPasswordForm'
import { Helmet } from 'react-helmet-async'

export const ResetPasswordScreen = () => {
  return (
    <Box>
      <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
        <title>Reset Password</title>
      </Helmet>
      <TempNavbar />
      <ResetPasswwordForm />
    </Box>
  )
}
